import { DocumentsContextProvider } from 'src/contexts/FileManagerContext';

import DrawerV2 from './DrawerV2';
import type { SidebarState } from './hooks';

export interface SidebarV2RootProps {
  state?: SidebarState;
}

const SidebarV2Root = ({ state }: SidebarV2RootProps) => (
  <DocumentsContextProvider>
    <DrawerV2 state={state} />
  </DocumentsContextProvider>
);

export default SidebarV2Root;
